import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/actionCreators';
import './WelcomeToBookApp.css';

class WelcomeToBookApp extends React.Component {
    constructor(props) {
        super(props);
        this.chooseUser = this.chooseUser.bind(this);
    }

    chooseUser(userId) {
        var { setCurrentUser, permissions, users } = this.props;
        console.log('chooseUser');
        setCurrentUser(userId, users);

        if (permissions.associateAdvocates.find((user) => user === userId) ||
            permissions.resource.find((user) => user === userId)) {
            browserHistory.push('/admin');
        } else {
            browserHistory.push('/user');
        }
    }

    render() {
        return (
            <div className="welcome-to-book-app">
                <h1>Welcome to the ICC Book Request App</h1>
                <p>Please Choose a user</p>
                <button onClick={this.chooseUser.bind(this, 'ceno')}>User (ceno)</button>
                <button onClick={this.chooseUser.bind(this, 'afiore')}>Associate Advocate (afiore)</button>
                <button onClick={this.chooseUser.bind(this, 'gbaker')}>Resource Manager (gbaker)</button>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        users: state.users,
        currentUser: state.currentUser,
        requests: state.requests,
        permissions: state.permissions
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeToBookApp);



/** WEBPACK FOOTER **
 ** ./src/components/WelcomeToBookApp/WelcomeToBookApp.js
 **/